import { render, staticRenderFns } from "./MergeFields.vue?vue&type=template&id=3dd7ef81&"
import script from "./MergeFields.vue?vue&type=script&lang=js&"
export * from "./MergeFields.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports